import messages from '../../../../locale/messages';
import { inputTextLimit, inputDescLimit, containsMalicious } from '../../../../helpers/textRestriction';

const validate = values => {

  const errors = {}

  if (!values.quoteSectionTitle1) {
    errors.quoteSectionTitle1 = messages.required;
  } else if (values.quoteSectionTitle1.trim() == "") {
    errors.quoteSectionTitle1 = messages.required;
  } else if (values.quoteSectionTitle1 && values.quoteSectionTitle1.length > inputTextLimit) {
    errors.quoteSectionTitle1 = messages.inputFieldRestriction;
  } else if (containsMalicious(values.quoteSectionTitle1)) {
    errors.quoteSectionTitle1 = messages.invalidInput;;
  }

  if (!values.quoteSectionTitle2) {
    errors.quoteSectionTitle2 = messages.required;
  } else if (values.quoteSectionTitle2.trim() == "") {
    errors.quoteSectionTitle2 = messages.required;
  } else if (values.quoteSectionTitle2 && values.quoteSectionTitle2.length > inputTextLimit) {
    errors.quoteSectionTitle2 = messages.inputFieldRestriction;
  } else if (containsMalicious(values.quoteSectionTitle2)) {
    errors.quoteSectionTitle2 = messages.invalidInput;;
  }

  if (!values.quoteSectionContent1) {
    errors.quoteSectionContent1 = messages.required;
  } else if (values.quoteSectionContent1.trim() == "") {
    errors.quoteSectionContent1 = messages.required;
  } else if (values.quoteSectionContent1 && values.quoteSectionContent1.length > inputDescLimit) {
    errors.quoteSectionContent1 = messages.descriptionFieldRestriction;
  } else if (containsMalicious(values.quoteSectionContent1)) {
    errors.quoteSectionContent1 = messages.invalidInput;;
  }

  if (!values.quoteSectionContent2) {
    errors.quoteSectionContent2 = messages.required;
  } else if (values.quoteSectionContent2.trim() == "") {
    errors.quoteSectionContent2 = messages.required;
  } else if (values.quoteSectionContent2 && values.quoteSectionContent2.length > inputDescLimit) {
    errors.quoteSectionContent2 = messages.descriptionFieldRestriction;
  } else if (containsMalicious(values.quoteSectionContent2)) {
    errors.quoteSectionContent2 = messages.invalidInput;;
  }

  if (!values.quoteSectionButton1) {
    errors.quoteSectionButton1 = messages.required;
  } else if (values.quoteSectionButton1.trim() == "") {
    errors.quoteSectionButton1 = messages.required;
  } else if (values.quoteSectionButton1 && values.quoteSectionButton1.length > inputTextLimit) {
    errors.quoteSectionButton1 = messages.inputFieldRestriction;
  } else if (containsMalicious(values.quoteSectionButton1)) {
    errors.quoteSectionButton1 = messages.invalidInput;;
  }

  if (!values.quoteSectionButton2) {
    errors.quoteSectionButton2 = messages.required;
  } else if (values.quoteSectionButton2.trim() == "") {
    errors.quoteSectionButton2 = messages.required;
  } else if (values.quoteSectionButton2 && values.quoteSectionButton2.length > inputTextLimit) {
    errors.quoteSectionButton2 = messages.inputFieldRestriction;
  } else if (containsMalicious(values.quoteSectionButton2)) {
    errors.quoteSectionButton2 = messages.invalidInput;;
  }


  return errors
}

export default validate;